import { render, staticRenderFns } from "./member-configure-table.vue?vue&type=template&id=4d127a7c&scoped=true&"
import script from "./member-configure-table.vue?vue&type=script&lang=ts&"
export * from "./member-configure-table.vue?vue&type=script&lang=ts&"
import style0 from "./member-configure-table.vue?vue&type=style&index=0&id=4d127a7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d127a7c",
  null
  
)

export default component.exports